import { AgGridReact } from 'ag-grid-react'
import React, { useEffect, useState } from 'react'
import { Modal } from 'react-bootstrap';
import { useNavigate } from 'react-router-dom';
import { toast } from 'react-toastify';
import Swal from 'sweetalert2';
import { denocreate, denodelete, denolist, liststaff } from '../../../services/admin';
import moment from 'moment';
import { isAdmin } from "../../../utils/roles";
import { printDataTable } from "../../../utils/printTable";

export const Denomination = () => {
    const navigate = useNavigate();
    const [errmsg, setErrMsg] = useState("");
    const [filterProduct, setFilterProduct] = useState([]);
    const [blist, setBlist] = useState([]);
    const [branchid, setBranchId] = useState("");
    const [ddate, setDDate] = useState("");
    const [damt, setDAmt] = useState("");

    const [notes, setNotes] = useState({
        2000: { quantity: 0, total: 0 },
        500: { quantity: 0, total: 0 },
        200: { quantity: 0, total: 0 },
        100: { quantity: 0, total: 0 },
        50: { quantity: 0, total: 0 },
        20: { quantity: 0, total: 0 },
        10: { quantity: 0, total: 0 },
        5: { quantity: 0, total: 0 },
        2: { quantity: 0, total: 0 },
        1: { quantity: 0, total: 0 },
    });
    const handleQuantityChange = (denomination, event) => {
        const newQuantity = parseInt(event.target.value) || 0;
        setNotes((prevNotes) => ({
            ...prevNotes,
            [denomination]: { quantity: newQuantity, total: newQuantity * denomination },
        }));
    };

    const calculateTotal = () => {
        const total = Object.values(notes).reduce((acc, note) => {
            return acc + note.total;
        }, 0);
        return total;
    };

    const sortedDenominations = Object.keys(notes).sort((a, b) => parseInt(b) - parseInt(a));

    const handlePrint = () => {
        const noteColumns = [2000, 500, 200, 100, 50, 20, 10, 5, 2, 1].map((note) => ({
            header: String(note),
            align: "right",
            field: "deno_" + note
        }));

        printDataTable({
            title: "Denomination",
            orientation: "landscape",
            meta: [`Printed On: ${moment().format("DD-MM-YYYY hh:mm A")}`],
            columns: [
                { header: "Date", value: (row) => (row.deno_date ? moment(row.deno_date).format("DD-MM-YYYY") : "") },
                { header: "Staff", field: "staff_name" },
                { header: "Amount", align: "right", field: "deno_amount" },
                ...noteColumns
            ],
            rows: filterProduct
        });
    };

    const columnDefs = [
        {
            headerName: "Actions",
            field: "id",
            sortable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
            cellRenderer: function (params) {
                return (
                    <div className="text-center">
                        <a
                            onClick={()=>handleSwitch(params.value)}
                            className="btn-sm btn-danger me-2"
                        >
                            <i className="fa fa-trash"></i>
                        </a>
                    </div>
                );
            },
        },
        {
            headerName: "Date",
            field: "deno_date",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
            cellRenderer: function (params) {
                if (params.value !== null) {
                    return moment(params.value).format("DD-MM-YYYY");
                }
            }
        },
        {
            headerName: "Staff",
            field: "staff_name",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Amount",
            field: "deno_amount",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "2000",
            field: "deno_2000",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "500",
            field: "deno_500",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "200",
            field: "deno_200",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "100",
            field: "deno_100",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "50",
            field: "deno_50",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "20",
            field: "deno_20",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "10",
            field: "deno_10",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "5",
            field: "deno_5",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },{
            headerName: "2",
            field: "deno_2",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },{
            headerName: "1",
            field: "deno_1",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        }

    ];

    const columnDDefs = [
       
        {
            headerName: "Date",
            field: "deno_date",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
            cellRenderer: function (params) {
                if (params.value !== null) {
                    return moment(params.value).format("DD-MM-YYYY");
                }
            }
        },
        {
            headerName: "Staff",
            field: "staff_name",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "Amount",
            field: "deno_amount",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "2000",
            field: "deno_2000",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "500",
            field: "deno_500",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "200",
            field: "deno_200",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "100",
            field: "deno_100",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "50",
            field: "deno_50",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "20",
            field: "deno_20",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "10",
            field: "deno_10",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },
        {
            headerName: "5",
            field: "deno_5",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },{
            headerName: "2",
            field: "deno_2",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        },{
            headerName: "1",
            field: "deno_1",
            sortable: true,
            resizable: true,
            filter: true,
            floatingFilter: true,
            cellStyle: { textAlign: "left" },
        }

    ];
    useEffect(() => {
        setDDate(moment(new Date()).format("YYYY-MM-DD"));
        funlist();
        liststaff(localStorage.getItem("branch")).then((res) => {
            if (res.status === true) {
                setBlist(res.data.details);
            }
        })
    }, []);

    function funlist() {
        setFilterProduct([]);
        denolist().then((res) => {
            if (res.status === true) {
                setFilterProduct(res.data);
            }
        });
    }

    const [show, setShow] = useState(false);
    function handleShow() {
        setErrMsg("");
        setBranchId("");
        setDDate(moment(new Date()).format("YYYY-MM-DD"));
        setDAmt("");
        setNotes({
            2000: { quantity: 0, total: 0 },
            500: { quantity: 0, total: 0 },
            200: { quantity: 0, total: 0 },
            100: { quantity: 0, total: 0 },
            50: { quantity: 0, total: 0 },
            20: { quantity: 0, total: 0 },
            10: { quantity: 0, total: 0 },
            5: { quantity: 0, total: 0 },
            2: { quantity: 0, total: 0 },
            1: { quantity: 0, total: 0 },
        });
        setShow(true);

    }

    function handleclose() {
        setShow(false);
        setErrMsg("");
        setBranchId("");
        setDDate(moment(new Date()).format("YYYY-MM-DD"));
        setDAmt("");
        setNotes({
            2000: { quantity: 0, total: 0 },
            500: { quantity: 0, total: 0 },
            200: { quantity: 0, total: 0 },
            100: { quantity: 0, total: 0 },
            50: { quantity: 0, total: 0 },
            20: { quantity: 0, total: 0 },
            10: { quantity: 0, total: 0 },
            5: { quantity: 0, total: 0 },
            2: { quantity: 0, total: 0 },
            1: { quantity: 0, total: 0 },
        });
    }

    function handlebranch(e) {
        e.preventDefault();
        setErrMsg("");
        if (branchid !== "") {
            if (damt !== "") {
                const denominationData = [];
                let hasNonZeroQuantity = false;
                for (const denomination in notes) {
                    const { quantity, total } = notes[denomination];
                    if (quantity > 0) {
                        hasNonZeroQuantity = true;
                    }

                    denominationData.push({
                        denomination: denomination,
                        quantity: quantity,
                        total: total
                    });
                }
                if (!hasNonZeroQuantity) {
                    setErrMsg("Please Select at Least One Denomination");
                    return;
                }

                if (parseFloat(damt) !== calculateTotal()) {
                    setErrMsg("Denomination Amount Not Match");
                    return;
                }

                const temp = new FormData();
                temp.append("deno_staff", branchid);
                temp.append("deno_date", ddate);
                temp.append("deno_amount", damt);
                temp.append("deno_2000", notes["2000"].quantity);
                temp.append("deno_500", notes["500"].quantity);
                temp.append("deno_200", notes["200"].quantity);
                temp.append("deno_100", notes["100"].quantity);
                temp.append("deno_50", notes["50"].quantity);
                temp.append("deno_20", notes["20"].quantity);
                temp.append("deno_10", notes["10"].quantity);
                temp.append("deno_5", notes["5"].quantity);
                temp.append("deno_2", notes["2"].quantity);
                temp.append("deno_1", notes["1"].quantity);
                denocreate(temp).then((response) => {
                    if (response.status === true) {
                        funlist();
                        handleclose();
                        toast.success(response.message);
                    }
                })
            } else {
                setErrMsg("Please Enter Denomination Amount");
            }
        } else {
            setErrMsg("Please Select Staff");
        }
    }


    function handleSwitch(list) {
        Swal.fire({
            text: "Are you sure want to Delete?",
            icon: "warning",
            showCancelButton: true,
            confirmButtonColor: "#ac0404",
            cancelButtonColor: "#6259ca",
            confirmButtonText: "Delete",
            allowOutsideClick: false,
        }).then((result) => {
            if (result.isConfirmed) {

                denodelete(list).then((response) => {
                    if (response.status === true) {
                        funlist();
                    }
                });
            }
        });

    }

    const handleAmount = (e) => {
        const regex = /^[0-9\b]+$/;
        if (e.target.value === "" || regex.test(e.target.value)) {
            setDAmt(e.target.value);
        }
    };


    return (
        <div>
            <div className="page-header">
                <h2 className="main-content-title tx-24 mg-b-5">Denomination</h2>
                <ol className="breadcrumb">
                    <li className="breadcrumb-item">
                        <a>Report</a>
                    </li>
                    <li className="breadcrumb-item active" aria-current="page">
                        Denomination
                    </li>
                </ol>
            </div>
            <div className='d-flex justify-content-end'>
                <a className='btn btn-success me-2' onClick={handleShow}>Add Denomination</a>
                <a className='btn btn-primary' onClick={handlePrint}>Print</a>
            </div>
            <div className="ag-theme-alpine ag-style mt-2">
                <AgGridReact
                    columnDefs={isAdmin() ? columnDefs : columnDDefs}
                    rowData={filterProduct}
                    pagination="true"
                    paginationPageSize="10"
                    sortingOrder={["asc", "desc"]}
                    suppressDragLeaveHidesColumns={true}
                />
            </div>

            <Modal show={show} onHide={() => setShow(false)}>
                <Modal.Header>
                    <h4>Add Denomination</h4>
                </Modal.Header>
                <Modal.Body>
                    <div className='row'>
                        <div className="col-md-12">
                            <div className="mb-3">
                                <label className="form-label">Staff <span className="text-danger"> *</span></label>
                                <select
                                    className="form-control"
                                    value={branchid}
                                    onChange={(e) => setBranchId(e.target.value)}
                                >
                                    <option value="">Select Staff</option>
                                    {blist.map((item, index) => (
                                        <option key={index} value={item.id}>
                                            {item.staff_name}
                                        </option>
                                    ))}
                                </select>
                            </div>
                        </div>

                        <div className="col-md-12">
                            <div className="mb-3">
                                <label className="form-label">Date <span className="text-danger"> *</span></label>
                                <input
                                    type="date"
                                    className="form-control"
                                    value={ddate}
                                    onChange={(e) => setDDate(e.target.value)}
                                />
                            </div>
                        </div>

                        <div className="col-md-12">
                            <div className="mb-3">
                                <label className="form-label">Denomination Amount <span className="text-danger"> *</span></label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Enter Denomination Amount"
                                    value={damt}
                                    onChange={handleAmount}
                                />
                            </div>
                        </div>

                        {sortedDenominations.map((denomination) => (
                            <div className="row" key={denomination}>
                                <div className="col-md-3">
                                    <div className="mb-3">
                                        <label className="form-label">{`${denomination} X`}</label>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="mb-3">
                                        <input
                                            type="number"
                                            className="form-control"
                                            placeholder="Enter Quantity"
                                            value={notes[denomination].quantity}
                                            onChange={(e) => handleQuantityChange(denomination, e)}
                                        />
                                    </div>
                                </div>
                                <div className="col-md-1">
                                    <div className="mt-2">
                                        <label className="form-label">=</label>
                                    </div>
                                </div>
                                <div className="col-md-4">
                                    <div className="mb-3">
                                        <input
                                            type="text"
                                            className="form-control"
                                            placeholder="Total Amount"
                                            value={notes[denomination].total}
                                            readOnly
                                        />
                                    </div>
                                </div>
                            </div>

                        ))}
                        <div className="col-md-12">
                            <div className="mb-3">
                                <label className="form-label">Total Amount</label>
                                <input
                                    type="text"
                                    className="form-control"
                                    placeholder="Total Amount"
                                    value={calculateTotal()}
                                    readOnly
                                />
                            </div>
                        </div>
                        {errmsg && <span className='text-danger'>{errmsg}</span>}
                    </div>
                </Modal.Body>
                <Modal.Footer>
                    <a className='btn btn-success' onClick={handlebranch}>Submit</a>
                    <a className='btn btn-info' onClick={() => setShow(false)}>Close</a>
                </Modal.Footer>
            </Modal>
        </div>
    )
}
